







































































import { TbMember, TbReturnOrder } from '@/http';
import { Toast } from 'vant';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
@Component({
    components: {
    },
})
export default class editReturnProduct extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        type:Object,
        default:()=>{
            return {

            }
        }
    })
    orderForm:any;

    list=[];

    form={
        sellingPrice:null,
        num:null
    }

    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }
    value=null;
    maxLength=10;

    key="";
    editNumType=null;

    isEdit = false;
    
    fmoney = fmoney;

    /**计算商品原价 */
    getSellingPrice=0;
    /**实际零售价 */
    getFinalPrice=0;
    created() {
        
        this.form.num = this.orderForm.returnNum; 
        this.form.sellingPrice = this.orderForm.nowtotalPrice; 
        this.getSellingPrice = this.orderForm.totalSellPrice;
        this.getFinalPrice = this.orderForm.totalPrice;
    }   
    
    mounted() {
       
    }

    closeFun(){
        this.$emit('closeFun');
    }

    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun();
        }
	number(number) {
		// this.$emit("number", number);
        if(!this.editNumType){
            this.editNumType=1;
        }
        if(number=='.'&&this.editNumType==2) return;
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}


	clearFun(){
            this.value = null;
            this.finishFun();
    }
    finishFun(){
        if(!this.editNumType) return;
        if(this.editNumType==1){
            let maxVal = this.getFinalPrice;
            if(this.value<=maxVal){
                this.form.sellingPrice = this.value;
            }else{
                this.form.sellingPrice = maxVal;
                this.value = maxVal;
            }
        }else{
            if(this.value<=this.orderForm.canReturnNum){
                this.form.num = this.value;
            }else{
                this.form.num = this.orderForm.canReturnNum;
                this.value = this.orderForm.canReturnNum;
            }
            this.calReturnTaotal();
        }
    }
    /**退货数量改变计算退回总额 */
    async calReturnTaotal(){
        if(this.form.num){
            let res = await TbReturnOrder.GetReturnOrderInfo({
                orderId:this.orderForm.orderId,
                items:[{
                    goodsItemId:this.orderForm.goodsItemId,
                    num:this.form.num,
                    isGift:this.orderForm.isGift
                }]
            })
            if(res.items&&res.items.length>0){
                let nItem = res.items[0]
                this.form.sellingPrice = nItem.totalPrice;
                this.getSellingPrice = nItem.totalSellPrice;
                this.getFinalPrice = nItem.totalPrice;
            }


        }else{
            this.form.sellingPrice = null;
        }
    }

    setNumVal(val,type){
        this.maxLength = type==1?10:4;
        this.value = val;
        this.editNumType = type;
    }
    confirmFun(){
        if(!this.form.num){
            Toast("请填写退货数量");
            return;
        }
        if(Number(this.form.num)==0){
            Toast("数量不能为0");
            return;
        }
        let obj = Object.assign({},this.form,
            {
                sellingPrice:this.form.sellingPrice?this.form.sellingPrice:0,
                sellingPriceTotal:this.getSellingPrice,
                actualReturnPriceTotal:this.getFinalPrice
            }
        )
        this.$emit("editReturnProduct",obj);
        this.closeFun();
    }
    minusFun(){
        this.editNumType = 2;
        if(!this.form.num||Number(this.form.num)==0) return;
        this.form.num--;
        this.calReturnTaotal();
    }
    addFun(){
        this.editNumType = 2;
        if(Number(this.form.num)>=this.orderForm.canReturnNum) return;
        if(Number(this.form.num)==9999) return;
        if(!this.form.num){
            this.form.num=1
        }else{
            this.form.num++;
        }
        this.calReturnTaotal();
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/editReturnProduct.vue